import React from 'react';
import RestaurantWithTurnOffComment from './components/RestaurantWithTurnOffComment';
import RestaurantWithRequiredComment from './components/RestaurantWithRequiredComment';
import style from './RestaurantsForComments.module.scss';

const RestaurantsForComments: React.FC = () => {
	return (
		<div className={style.container}>
			<RestaurantWithTurnOffComment />
			<RestaurantWithRequiredComment />
		</div>
	);
};

export default RestaurantsForComments;
